/*
 * File: CustomDealForm.tsx
 * Project: a-a
 * File Created: Saturday, 21st June 2025 4:55:07 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 23rd October 2025 11:29:20 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useState } from 'react';
import CustomModal from '../../CustomModal/CustomModal';
import {
  Box,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  Skeleton,
  Typography,
  useTheme,
} from '@mui/material';
import CustomCard from '../../CustomCard/CustomCard';
import zeplinColor from '../../../../theme/Color';
import CustomButton from '../../CustomButton/CustomButton';
import CustomDrawer from '../../CustomDrawer/CustomDrawer';
import MarketingFormField from './DealFormField/MarketingFormField';
import AdvertisingFormField from './DealFormField/AdvertisingFormField';
import DevelopmentFormField from './DealFormField/DevelopmentFormField';
import FundraisingFormField from './DealFormField/FundraisingFormField';
import LicensingFormField from './DealFormField/LicensingFormField';
import TalentFormField from './DealFormField/TalentFormField';
import CustomStepper from '../../CustomStepper/CustomStepper';
import PriceBookField from './DealFormField/PriceBookField';
import AddProductFormField from './DealFormField/AddProductFormField';
import { ClientService } from '../../../../service/client.service';
import { Utilities } from '../../../../utilities/utilities';
import { useLocation, useParams } from 'react-router-dom';
import CustomAlert from '../../CustomAlert/CustomAlert';
import CustomAlertContain from '../../CustomAlert/CustomAlertContain';
import { parse } from 'path';
import style from './CustomDealForm.module.css';

const CustomDealForm = ({
  setOpen,
  setDealMessage,
  selectedDeal,
  activeDealTab,
}: {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setDealMessage: React.Dispatch<React.SetStateAction<string>>;
  selectedDeal?: any;
  activeDealTab?: string;
}) => {
  const location = useLocation();
  const theme = useTheme();
  const SFToken = sessionStorage.getItem('sfToken');
  let accessToken: any = {};
  if (SFToken) {
    accessToken = JSON.parse(SFToken);
  }

  const [modalOpen, setModalOpen] = React.useState(typeof selectedDeal === 'string' ? false : true);
  const [loading, setLoading] = React.useState(false);
  const [dealTypeSelected, setDealTypeSelected] = React.useState('');
  const [drawerState, setDrawerState] = React.useState(
    typeof selectedDeal === 'string' ? true : false,
  );
  const [activeStep, setActiveStep] = React.useState(0);
  const [formValues, setFormValues] = React.useState<Record<string, any>>({}); // State to collect all input values
  const [pricebookName, setPricebookName] = useState('');
  const [error, setError] = useState(false);
  const [message, setMessage] = useState('');
  const [opportunityId, setOpportunityId] = useState('');
  const [parsed, setParsed] = useState<any>(null);
  const [valid, setIsValid] = useState(false);
  const [confirmChangePriceBookModal, setConfirmChangePriceBookModal] = useState(false);
  const [completed, setCompleted] = React.useState<{
    [k: number]: boolean;
  }>({});

  const [recordType, setRecordType] = useState<any>({});

  const handleInputChange = (field: string, value: any, index?: number) => {
    if (index != undefined) {
      setFormValues((prev) => {
        const updatedProducts = prev?.products?.length
          ? [...prev?.products]
          : parsed?.products?.length
          ? Array(parsed.products.length).fill({})
          : prev?.products?.length
          ? Array(prev.products.length).fill({})
          : []; // Create a copy of the products array
        updatedProducts[index] = {
          ...updatedProducts[index],
          [field]: value, // Update the specific field for the correct index
        };
        return {
          ...prev,
          products: updatedProducts, // Update the products array in formValues
        };
      });
    } else {
      setFormValues((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
    if (field === 'pricebook2Id' && (parsed?.dealId || opportunityId)) {
      setConfirmChangePriceBookModal(true);
    }
  };
  // console.log(formValues);
  const handleModalClose = (next = false) => {
    setModalOpen(false);
    // Optionally, you can also reset the selected task type
    // setDealTypeSelected('');
    !next && setOpen(false);
    sessionStorage.removeItem('sf_path');
    sessionStorage.removeItem('sf_redirect');
    sessionStorage.removeItem('selectedDeal');
    sessionStorage.removeItem('activeDealTab');
  };
  const handleTaskType = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDealTypeSelected(event.target.value);
    // Optionally, you can also close the modal after selecting a task type
    // handleModalClose();
  };
  const onClose = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    //   setSelectedFiles([...selectedData?.attachments]);
    //   console.log('onClose', open, drawerState);
    setDrawerState(open);
    setOpen(open);
    sessionStorage.removeItem('selectedDeal');
    // setDeleted(true);
    sessionStorage.removeItem('sf_path');

    sessionStorage.removeItem('sf_redirect');
    sessionStorage.removeItem('activeDealTab');
  };

  const handleSubmitPriceBook = async () => {
    try {
      if (!Object.keys(formValues)?.length) {
        setActiveStep(2);
        return;
      }
      setLoading(true);
      const {
        commission,
        estimatedValuation,
        pricebook2Id,
        opportunityName,
        opportunityType,
        lastModifiedDate,
        createdByName,
        products,
        ...rest
      } = formValues;
      const res =
        parsed?.dealId || opportunityId
          ? await ClientService.editDeal(parsed?.dealId || opportunityId, {
              ...rest,

              // gdEquity: formValues?.gdEquity ? formValues?.gdEquity : false,
              // }),
              ...(formValues?.gdEquity && {
                gdEstimatedValuation: formValues?.gdEstimatedValuation
                  ? formValues?.gdEstimatedValuation
                  : estimatedValuation,
              }),
              gdCommission: formValues?.gdCommission ? formValues?.gdCommission : commission,
              ...(formValues?.equity && {
                reasonLost: formValues?.reasonLost,
              }),
              ...(formValues?.pricebook2Id !== 'none' &&
                formValues?.pricebook2Id && {
                  pricebook2Id: formValues?.pricebook2Id,
                }),
              // accountId: location?.pathname?.split('/')[2],
              access_token: accessToken?.access_token,
            })
          : await ClientService.addDeal({
              ...rest,
              recordTypeName: Utilities.getMatchingRecordTypeKey(
                dealTypeSelected,
                recordType,
              )?.replace(' Deal', ''),
              gdEquity: formValues?.gdEquity ? formValues?.gdEquity : false,
              ...(formValues?.gdEquity && {
                // gdEquity: formValues?.gdEquity ? formValues?.gdEquity : false,
                gdEstimatedValuation: formValues?.gdEstimatedValuation,
              }),
              gdCommission: formValues?.gdCommission ? formValues?.gdCommission : commission,

              ...(formValues?.equity && {
                // gdEquity: formValues?.gdEquity ? formValues?.gdEquity : false,
                reasonLost: formValues?.reasonLost,
              }),
              ...(formValues?.pricebook2Id !== 'none' &&
                formValues?.pricebook2Id && {
                  pricebook2Id: formValues?.pricebook2Id,
                }),
              accountId: location?.pathname?.split('/')[2],
              access_token: accessToken?.access_token,
            });

      setOpportunityId(opportunityId ? opportunityId : res.opportunityId || formValues?.dealId);
      sessionStorage.setItem(
        'dealSelectedFromOverview',
        (parsed?.dealId
          ? parsed?.dealId
          : opportunityId
          ? opportunityId
          : res.opportunityId || formValues?.dealId || '0'
        ).toString(),
      );
      parsed?.dealId &&
        setParsed((prev: any) => ({
          ...prev,
          pricebook2Id: formValues?.pricebook2Id ? formValues?.pricebook2Id : parsed?.pricebook2Id,
        }));

      if (formValues?.pricebook2Id && formValues?.pricebook2Id !== parsed?.pricebook2Id) {
        const { products: _parsedProducts, ...restParsed } = parsed || {};
        const { products: _formProducts, ...restFormValues } = formValues || {};
        setParsed(restParsed);
        setFormValues(restFormValues);
      }
      setDealMessage(
        `Deal ${opportunityId || parsed?.dealId ? 'updated' : 'created'} successfully`,
      );
      if (
        (formValues?.pricebook2Id !== 'none' && formValues?.pricebook2Id) ||
        parsed?.pricebook2Id
      ) {
        setActiveStep(2);
      } else {
        setOpen(false);
        sessionStorage.removeItem('selectedDeal');
        sessionStorage.removeItem('sf_redirect');
        sessionStorage.removeItem('activeDealTab');
        sessionStorage.removeItem('sf_path');
      }
      confirmChangePriceBookModal && handleCloseChangePriceBookModal();
    } catch (err) {
      setError(true);
      setMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const createPricebookProducts = async () => {
    try {
      setLoading(true);

      if (typeof selectedDeal === 'string') {
        if (parsed?.products && parsed?.products?.length) {
          const promises = (formValues?.products || [])?.map(
            (product: any, index: number) =>
              Object.keys(product)?.length &&
              ClientService.editPricebookProducts(
                {
                  access_token: accessToken?.access_token,
                  ...product, // Pass the single product as an array
                },
                parsed?.products[index]?.opportunityLineItemId, // Use the respective opportunityLineItemId
              ),
          );
          await Promise.all(promises);
        }
      }

      !parsed?.products &&
        !parsed?.products?.length &&
        (await ClientService.addPricebookProducts({
          access_token: accessToken?.access_token,
          items: formValues?.products,
        }));

      setDealMessage(`Product ${parsed?.products ? 'updated' : 'added'} successfully`);

      setOpen(false);
      sessionStorage.removeItem('selectedDeal');
    } catch (err) {
      setError(true);
      setMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };
  const getRecordType = async () => {
    try {
      setLoading(true);
      const res = await ClientService.getDealType();
      setRecordType(res);
    } catch (err) {
      setError(true);
      setMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };
  const handleClose = () => {
    setError(false);
    setMessage('');
  };
  const handleCloseChangePriceBookModal = () => {
    setConfirmChangePriceBookModal(false);
  };

  useEffect(() => {
    if (Object.keys(recordType)?.length && typeof selectedDeal === 'string') {
      const parsedObj = JSON.parse(selectedDeal);
      parsedObj.opportunityType &&
        setDealTypeSelected(recordType[`${parsedObj?.opportunityType} Deal`]);
      setParsed(parsedObj);
    }
  }, [selectedDeal?.opportunityType, Object.keys(recordType)?.length]);
  useEffect(() => {
    getRecordType();
    setActiveStep(+(activeDealTab || '0'));
  }, []);

  return (
    <>
      <CustomModal handleClose={() => {}} open={modalOpen}>
        <Box
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: '24px',
              backgroundColor: zeplinColor.Neutral1,

              width: { xs: '280px', xl: '312px' },
              // height: '183px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              // display: 'flex',
              // flexDirection: 'column',
              // justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '18px', xl: '24px' },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                  Select Deal Type
                </Typography>
                <img
                  src={'/assets/cross.svg'}
                  alt='logo'
                  className={style['icon']}
                  onClick={() => handleModalClose(false)}
                  style={{ cursor: 'pointer' }}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <RadioGroup
                  aria-labelledby='demo-controlled-radio-buttons-group'
                  name='controlled-radio-buttons-group'
                  value={dealTypeSelected}
                  onChange={handleTaskType}
                  sx={{
                    color: zeplinColor.BasicBlack,
                    '&.Mui-checked': {
                      color: zeplinColor.BasicBlack,
                    },
                    padding: '0px',
                  }}
                >
                  {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        width: '100%',
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    Object.keys(recordType).map((name) => (
                      <FormControlLabel
                        value={recordType[name]}
                        control={
                          <Radio
                            sx={{
                              color: zeplinColor.BasicBlack,
                              '&.Mui-checked': {
                                color: zeplinColor.BasicBlack,
                              },
                            }}
                          />
                        }
                        label={name}
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '& .MuiButtonBase-root': {
                            color: zeplinColor.BasicBlack,
                            // border: `1px solid ${zeplinColor.BasicBlack}`,
                          },
                          padding: '0px',
                        }}
                      />
                    ))
                  )}
                </RadioGroup>
              </Box>
              <CustomButton
                //   disabled={recordType[0] ? false : true}
                disabled={!dealTypeSelected}
                onClick={() => {
                  setDrawerState(true);
                  handleModalClose(true);
                }}
                variant='contained'
                color={'primary'}
                style={{
                  width: '100%',
                  borderRadius: '14px',
                  height: 48,
                  padding: '14px 16px',
                  '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                }}
                textStyle={{ color: zeplinColor.Neutral1 }}
                text={'Continue'}
                // tabindex={4}
              />
            </Box>
          </CustomCard>
          {/* {loading ? <CustomLoader /> : ''} */}
        </Box>
      </CustomModal>
      <CustomDrawer state={drawerState} onClose={onClose(false)}>
        <Box
          sx={{
            width: { xs: '427px', xl: '527px' },
            position: 'relative',
            overflowY: 'scroll',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
          }}
        >
          {' '}
          <Box
            sx={{ position: 'sticky', top: 0, backgroundColor: zeplinColor.Neutral1, zIndex: 10 }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: { xs: '24px 24px 24px 24px', xl: '40px 24px 24px 24px' },
              }}
            >
              <Typography variant='responsiveHeading2'>
                {parsed?.dealId || typeof selectedDeal === 'string' ? 'Edit Deal' : 'New Deal: '}{' '}
                {parsed?.dealId
                  ? ''
                  : Utilities.getMatchingRecordTypeKey(dealTypeSelected, recordType)}
              </Typography>
              <img
                src={'/assets/close-icon.svg'}
                width={'24px'}
                height={'24px'}
                alt='close'
                style={{ cursor: 'pointer' }}
                onClick={onClose(false)}
              />
            </Box>
            <Divider
              component='div'
              sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
            />
            <CustomStepper
              activeStep={activeStep}
              setActiveStep={setActiveStep}
              setCompleted={setCompleted}
              completed={completed}
            />
          </Box>
          {activeStep === 0 ? (
            <Box
              sx={{
                display: 'flex',
                gap: { xs: '16px', xl: '24px' },
                flexDirection: 'column',
                padding: { xs: '16px 24px 24px', xl: '24px' },
              }}
            >
              {dealTypeSelected === recordType['Marketing Deal'] && (
                <MarketingFormField
                  handleInputChange={handleInputChange}
                  value={parsed?.dealId ? parsed : formValues}
                  dealType={dealTypeSelected}
                  setIsValid={setIsValid}
                />
              )}
              {dealTypeSelected === recordType['Advertising Deal'] && (
                <AdvertisingFormField
                  handleInputChange={handleInputChange}
                  value={parsed?.dealId ? parsed : formValues}
                  dealType={dealTypeSelected}
                  setIsValid={setIsValid}
                />
              )}
              {dealTypeSelected === recordType['Development Deal'] && (
                <DevelopmentFormField
                  handleInputChange={handleInputChange}
                  value={parsed?.dealId ? parsed : formValues}
                  dealType={dealTypeSelected}
                  setIsValid={setIsValid}
                />
              )}
              {dealTypeSelected === recordType['Fundraising Deal'] && (
                <FundraisingFormField
                  handleInputChange={handleInputChange}
                  value={parsed?.dealId ? parsed : formValues}
                  dealType={dealTypeSelected}
                  setIsValid={setIsValid}
                />
              )}
              {dealTypeSelected === recordType['Licensing Deal'] && (
                <LicensingFormField
                  handleInputChange={handleInputChange}
                  value={parsed?.dealId ? parsed : formValues}
                  dealType={dealTypeSelected}
                  setIsValid={setIsValid}
                />
              )}
              {dealTypeSelected === recordType['Talent Deal'] && (
                <TalentFormField
                  handleInputChange={handleInputChange}
                  value={parsed?.dealId ? parsed : formValues}
                  dealType={dealTypeSelected}
                  setIsValid={setIsValid}
                />
              )}
            </Box>
          ) : activeStep === 1 ? (
            <Box sx={{ display: 'flex', gap: '24px', flexDirection: 'column', padding: '24px' }}>
              <PriceBookField
                handleInputChange={handleInputChange}
                value={formValues?.pricebook2Id ? formValues : parsed}
                modal={confirmChangePriceBookModal}
                setPricebookName={setPricebookName}
                key={formValues?.pricebook2Id ? formValues?.pricebook2Id : parsed?.pricebook2Id}
              />
            </Box>
          ) : (
            <Box sx={{ display: 'flex', gap: '24px', flexDirection: 'column', padding: '24px' }}>
              <AddProductFormField
                handleInputChange={handleInputChange}
                value={formValues?.pricebook2Id ? formValues : parsed}
                opportunityId={opportunityId || parsed?.dealId}
                pricebookName={pricebookName}
                key={formValues?.pricebook2Id ? formValues?.pricebook2Id : parsed?.pricebook2Id}
              />
            </Box>
          )}
          <Box
            sx={{
              width: '100%',
              position: 'sticky',
              bottom: '0px',
              margin: 'auto',
              zIndex: '100',
              padding: '24px',
              backgroundColor: zeplinColor.Neutral1,
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
            }}
          >
            <Box sx={{ display: 'flex', gap: '24px' }}>
              {activeStep > 0 && (
                <CustomButton
                  disabled={false}
                  onClick={() => {
                    setActiveStep((prev) => prev - 1);
                  }}
                  variant='outlined'
                  color={'customSecondary'}
                  style={{
                    borderRadius: '14px',
                    height: 56,
                    width: '100%',
                    border: `1px solid ${zeplinColor.BasicBlack}`,
                    '&.Mui-focusVisible': { backgroundColor: zeplinColor.Neutral1 },
                    flex: 1,
                  }}
                  textStyle={{
                    color: zeplinColor.BasicBlack,
                  }}
                  text={'Back'}
                  // tabindex={4}
                />
              )}
              <CustomButton
                disabled={
                  (activeStep === 0 && valid) ||
                  // (activeStep === 1 && !formValues?.pricebook2Id) ||
                  loading
                }
                onClick={
                  activeStep === 0
                    ? () => {
                        setActiveStep((prev) => prev + 1);
                      }
                    : activeStep === 1
                    ? handleSubmitPriceBook
                    : activeStep === 2
                    ? createPricebookProducts
                    : () => {}
                }
                variant='contained'
                color={
                  (activeStep === 0 && valid) ||
                  // (activeStep === 1 && !formValues?.pricebook2Id) ||
                  loading
                    ? 'customDisable'
                    : 'primary'
                }
                style={{
                  borderRadius: '14px',
                  height: 56,
                  width: '100%',
                  '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                  flex: activeStep > 0 ? 3 : 1,
                }}
                textStyle={{
                  color:
                    (activeStep === 0 && valid) ||
                    // (activeStep === 1 && !formValues?.pricebook2Id) ||
                    loading
                      ? zeplinColor.Neutral8
                      : zeplinColor.Neutral1,
                }}
                text={
                  activeStep === 1
                    ? parsed?.dealId || opportunityId
                      ? 'Save & Continue'
                      : 'Create Deal'
                    : activeStep === 0
                    ? 'Continue'
                    : activeStep === 2
                    ? parsed?.dealId
                      ? 'Save'
                      : 'Add Products'
                    : 'Save'
                }
                // tabindex={4}
              />
            </Box>
          </Box>
        </Box>
      </CustomDrawer>
      <CustomModal handleClose={handleCloseChangePriceBookModal} open={confirmChangePriceBookModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: '24px',
              backgroundColor: zeplinColor.Neutral1,

              width: '375px',
              // height: '201px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              // display: 'flex',
              // flexDirection: 'column',
              // justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '32px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                }}
              >
                <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                  Confirm Price Book Change
                </Typography>
                <Typography variant='body2' color={zeplinColor.BasicBlack}>
                  You have changed the price book for ths deal. This action permanently deletes all
                  the products from the deal. Are you sure you want to continue?
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',

                  gap: '16px',
                }}
              >
                <Box
                  onClick={() => {
                    setFormValues((prev: any) => ({ ...prev, pricebook2Id: parsed?.pricebook2Id }));
                    // setParsed((prev: any) => ({ ...prev, pricebook2Id: parsed?.pricebook2Id }));
                    handleCloseChangePriceBookModal();
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                      Cancel
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={handleSubmitPriceBook}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: loading ? zeplinColor.Neutral5 : zeplinColor.Brand1,
                      cursor: 'pointer',
                      // border: `1px solid ${zeplinColor.BasicBlack}`,
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography
                      variant='buttonMedium'
                      color={zeplinColor.Neutral1}
                      sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                      Yes, Save
                    </Typography>
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
          {/* {loading ? <CustomLoader /> : ''} */}
        </Box>
      </CustomModal>
      <CustomAlert
        open={error ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alertIcon={
              error ? (
                <img src='/assets/error.svg' width={24} height={24} />
              ) : (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              )
            }
            alert={message}
          />
        }
        error={error}
      />
    </>
  );
};

export default CustomDealForm;
